import { AgentRecommendation } from '@/store/modules/propertyValuation/types';

// Hard-coded data to serve the purpose of the A/B/C test PP-3474
export const PP_3474_AgentRecommendationsForPlz: {
  [plz: string]: AgentRecommendation[];
} = {
  // TODO(PP-3497): replace this with the real data provided by PM later
  '8001': [
    {
      firstName: 'Lena',
      lastName: 'Keller',
      agencyName: 'Alpine Homes',
      agentDescription: {
        de: 'Ich begleite Verkaeufer seit 8 Jahren in der Region Bern.',
        en: 'I have been helping homeowners in Bern for over 8 years.',
        fr: 'J accompagne les proprietaires a Berne depuis plus de 8 ans.',
        it: 'Aiuto i proprietari a Berna da oltre 8 anni.',
      },
      location: 'Bern',
      yearsOfExp: '8',
      agentImageUrl: 'https://i.pravatar.cc/600?img=32',
      agencyId: 'heia',
    },
    {
      firstName: 'Marco',
      lastName: 'Rossi',
      agencyName: 'CityNest Realty',
      agentDescription: {
        de: 'Fokus auf schnelle Vermarktung und starke Verhandlung.',
        en: 'I specialize in fast listings and strong price negotiations.',
        fr: 'Je suis specialise dans les ventes rapides et la negociation des prix.',
        it: 'Sono specializzato in vendite rapide e forti negoziazioni sul prezzo.',
      },
      location: 'Zurich',
      yearsOfExp: '12',
      agentImageUrl: 'https://i.pravatar.cc/200?img=12',
      agencyId: 'heia',
    },
    {
      firstName: 'Sophie',
      lastName: 'Morel',
      agencyName: 'Lakeview Properties',
      agentDescription: {
        de: 'Erfahrung mit Einfamilienhaeusern und Eigentumswohnungen. Erfahrung mit Einfamilienhaeusern und Eigentumswohnungen. Erfahrung mit Einfamilienhaeusern und Eigentumswohnungen. Erfahrung mit Einfamilienhaeusern und Eigentumswohnungen.',
        en: 'Experienced with family homes and condominiums across Romandie. Experienced with family homes and condominiums across Romandie. Experienced with family homes and condominiums across Romandie. Experienced with family homes and condominiums across Romandie.',
        fr: 'Experience des maisons familiales et des appartements en Romandie.',
        it: 'Esperienza con case unifamiliari e appartamenti nella Svizzera romanda.',
      },
      location: 'Lausanne',
      yearsOfExp: '6',
      agentImageUrl: 'https://i.pravatar.cc/400?img=47',
      agencyId: 'heia',
    },
  ],
};

export enum PP_3474_SplitFeatureFlags_Treatments {
  NO_AGENT_RECOMMENDATIONS = 'treatment-A',
  REQUIRED_SELECTION_AGENT_RECOMENDATIONS = 'treatment-B',
  OPTIONAL_SELECTION_AGENT_RECOMMENDATIONS = 'treatment-C',
}

// Add the split feature flags for A/B test in the enum object
// for example: RDP375 = RDP-375_FeaturedAgencies_BackgroundColor, RDP375 is the split name that creating on split.io, only when at least one split exists will send the request to split.io
// Can't be deleted
export enum SplitFeatureFlags {
  DD4533_NEW_TOP_LEVEL_NAVIGATION = 'DD-4533-new-top-level-navigation',
  DD4035_NAVIGATION_EXPERIMENT = 'DD-4035-Alternate-Header-Navigation-Links',
  PP_3474 = 'PP-3474_show-agents-recommendation',
}
